import React from "react";
import styled from "@emotion/styled";
import {
  getClothesNameWarnings,
  getGenderMismatchWarning,
} from "../utils/productNameGuide";

// 의류(CLOTHES) 상품명 규칙 위반 경고 — 카테고리가 CLOTHES이고 경고가 있을 때만 노출, 비차단(제출은 막지 않음)
function ProductNameGuide({ category, name, gender }) {
  if (category !== "CLOTHES") return null;

  const warnings = getClothesNameWarnings(name);
  const genderWarning = getGenderMismatchWarning(name, gender);
  if (genderWarning) warnings.push(genderWarning);
  if (warnings.length === 0) return null;

  return (
    <GuideBox>
      {warnings.map((warning, i) => (
        <p key={`name_guide_warning_${i}`}>⚠ {warning}</p>
      ))}
    </GuideBox>
  );
}

const GuideBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 8px 10px;
  background: #fdf3f1;
  border: 1px solid #f5ddd8;
  border-radius: 8px;

  p {
    font-size: 12px;
    line-height: 1.5;
    color: #e25c3d;
  }
`;

export default ProductNameGuide;
